import { getBaselineLearningRatios } from '@/engine/calculateLearningRatios'
import type { LearningDimensionRatios, LearningLayer, LearningStageSnapshot } from '@/types'

export function createLearningStage(params: {
  layer: LearningLayer
  source: LearningStageSnapshot['source']
  dimensionRatios?: LearningDimensionRatios
  unitId?: string
  startedAt?: string
  id?: string
  reinforcementRound?: 0 | 2
}): LearningStageSnapshot {
  const startedAt = params.startedAt ?? new Date().toISOString()
  return {
    id: params.id ?? `stage-${startedAt}-${params.layer}`,
    layer: params.layer,
    dimensionRatios: params.dimensionRatios
      ? { ...params.dimensionRatios }
      : getBaselineLearningRatios(params.layer),
    startedAt,
    unitId: params.unitId,
    source: params.source,
    reinforcementRound: params.reinforcementRound ?? 0,
  }
}
